import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { categoriesApi } from './apis/categoriesApi';
import { contentApi } from './apis/contentApi';
import { galleryApi } from './apis/galleryApi';
import { newsApi } from './apis/newsApi';
import { postApi } from './apis/postApi';
import { userApi } from './apis/userApi';
import { changeToken, environmentReducer } from './slices/environmentSlice';

const store = configureStore({
    reducer: {
        environment: environmentReducer,
        [contentApi.reducerPath]: contentApi.reducer,
        [userApi.reducerPath]: userApi.reducer,
        [postApi.reducerPath]: postApi.reducer,
        [categoriesApi.reducerPath]: categoriesApi.reducer,
        [newsApi.reducerPath]: newsApi.reducer,
        [galleryApi.reducerPath]: galleryApi.reducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware()
        .concat(contentApi.middleware)
        .concat(userApi.middleware)
        .concat(postApi.middleware)
        .concat(newsApi.middleware)
        .concat(categoriesApi.middleware)
        .concat(galleryApi.middleware)
});

setupListeners(store.dispatch);

export { useGetCategoriesQuery } from './apis/categoriesApi';
export {
    useGetContentQuery,
    useSetContentMutation
} from './apis/contentApi';
export {
    useDeletePhotoMutation, useGetGalleryQuery,
    useSavePhotoMutation
} from './apis/galleryApi';
export {
    useGetNewsQuery,
    useGetCountsQuery
} from './apis/newsApi';
export {
    useDeletePostMutation,
    useGetPostQuery,
    useUpdatePostMutation
} from './apis/postApi';
export {
    useLoginUserMutation
} from './apis/userApi';
export { changeToken, store };
